export default {
  name: 'AdditionalDetails',
  props: ['item', 'isMultiPo'],
  methods: {
    getLabel(key) {
      return window.Granite.I18n.get(key);
    }
  }
};